import { isArray } from '../Array'
import type { ReadonlyRecord } from '../Types'

export const isNonArrayObject = (object: unknown): object is Record<string, unknown> | ReadonlyRecord<string, unknown> =>
    object !== null && typeof object === 'object' && !isArray(object)
